import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const CurrencySelector = props => {
    const options = props.currencies.map(elem => (
        {value: elem.id, label: elem.name}
    ));
    const defaultValue = options.find(currency => currency.value ===
        props.newOffer.currencyId);
    return (
        <React.Fragment>
            <Select
                name={props.name}
                closeMenuOnSelect={true}
                value={defaultValue ? defaultValue : ''}
                options={options}
                onChange={data => {
                    props.onCurrencyItemChange(data);
                }}
                styles={{
                    control: (styles, { data, isSelected }) => ({
                        ...styles,
                        color: '#3e5569',
                        backgroundColor: 'white',
                        borderColor: '#e9ecef'
                    }),
                    singleValue: (styles, { data }) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
                }}
            />
            {!props.disabled && (
                <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, position: 'absolute' }}
                    defaultValue={defaultValue}
                    required={props.required}
                />
            )}
        </React.Fragment>
    )
};

CurrencySelector.propTypes = {
    name: PropTypes.string,
    currencies: PropTypes.object,
    newOffer: PropTypes.object,
    onPaymentModelsItemChange: PropTypes.func
};

export default CurrencySelector ;


// WEBPACK FOOTER //
// ./src/components/Promo/Offer/CurrencySelector.js